import React from "react";
import { Redirect } from "react-router-dom";

export default class ProtectedRoute extends React.Component {
  render() {
    const Component = this.props.component;
    return this.props.auth.checkAuth() ? (
      <Component {...this.props} auth={this.props.auth} />
    ) : (
      <Redirect to={"/login"} />
    );
  }
}
